module.exports = __webpack_public_path__ + "img/cases-brand-tommee-7.5a2e1ab0.jpg";